import React from "react";
import "../styles/dashboard.css";
import GreetUser from './GreetUser';

const Title = () => {
 
  return (
    <div>

      <GreetUser prefixMessage="Welcome back" />
      <p className='mt-3 text-muted'> 
      Use this dashboard to identify, track, report on actions and manage YOUR account.
      </p>
    </div>
  );
};

export default Title;
